<template>
  <div class="task-detail-page">
    <TaskDetail
      :task-id="taskId"
      :project-id="projectId"
      :queue-id="queueId"
      :namespace-id="namespaceId"
      :tab="tab"
      :queueInfo="queueInfo"
      @checkIsUserAccessTask="emit('checkIsUserAccessTask', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, PropType, provide, ref } from 'vue';
import { TaskDetail, TaskDetailTabEnum } from '@/components';
import { useRoute } from 'vue-router';
import { ProjectQueueTaskListItem } from '@/components/tasks-kanban/adapter';

// #region defineProps
defineProps({
  /**информация очереди */
  queueInfo: {
    type: Array as PropType<ProjectQueueTaskListItem[]>,
  },
  /**ID задачи */
  taskId: {
    type: Number,
  },
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  /**Активный таб */
  tab: {
    type: Number as PropType<TaskDetailTabEnum>,
    default: () => TaskDetailTabEnum.Actions,
  },
});
// #endregion defineProps
const emit = defineEmits<{
  (e: 'checkIsUserAccessTask', checkIsUserAccessTask: boolean);
}>();

provide('popover-scroll-selector', '.project-list-wrapper-content');
provide('parent-scroll-container', '.project-list-wrapper-content');
</script>

<style lang="scss" scoped></style>
